import React, { useEffect, useState } from 'react';
import { FormikProvider, useFormik, Form } from 'formik';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { Paper, Button, CardContent, CardActions, Card, TextField, Box, Stack, FormControl, FormControlLabel, Checkbox, FormHelperText, MenuItem, Select, InputLabel, Autocomplete, Grid, Divider, Typography, TableRow, TableCell, IconButton, Modal } from '@mui/material';
import { Post, apiURL, Get } from '../../../utils/apiCalls';
import { LoadingButton } from '@mui/lab';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Base64File } from '../../../utils/Base64File';
import {dataURItoBlob } from '../../../utils/Base64File';
import LaunchIcon from '@mui/icons-material/Launch';
import InputAdornment from '@mui/material/InputAdornment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // Import the icon

const AgentSchema = Yup.object().shape({
   first_name: Yup.string().required('First Name is required'),
   last_name: Yup.string().required('Last Name is required'),
   email: Yup.string().email('Invalid Email').required('Email is required'),
   password: Yup.string().required('M-Pin is required').matches(/^[0-9]{4}$/, 'Invalid M-Pin'),
   // .min(6, 'M-Pin must be at least 6 characters')
   //    .matches(
   //       /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+])[a-zA-Z0-9!@#$%^&*()_+]+$/,
   //       'M-Pin must contain at least one capital letter, one symbol, and one number'
   //    ),
   phone: Yup.string().matches(/^[6-9]\d{9}$/, 'Please Enter valid Phone Number').required('Phone Number is required'),
   aadhar_number: Yup.string().matches(/^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/, 'Invalid Aadhar number').required('Aadhar Number is required'),
   pan_number: Yup.string().matches(/[A-Z]{5}[0-9]{4}[A-Z]{1}/, 'Invalid PAN number').required('Pan Number is required'),
   //  aadhar_upload: Yup.string().required('Aadhar Upload is required'),
   //  pan_upload: Yup.string().required('Pan Upload is required'),
   address: Yup.string().required('Personal Address is required'),
   city: Yup.string().required('City is required'),
   state: Yup.string().required('State is required'),
   country: Yup.string().required('Country is required'),
   pincode: Yup.string().required('Pincode is required'),
   // bank_name: Yup.string().required('Bank Name is required'),
   // account_number: Yup.string().required('Account Number is required'),
   // bank_ifsc_code: Yup.string().required('IFSC Number is required'),
   // bank_address: Yup.string().required('Bank Address is required'),
//    role: Yup.object().shape({ id: Yup.string().required('Role is required') }),
   active: Yup.string().required('Active is required'),
});

const AgentCreate = () => {
   const { qr } = useParams()
   // console.log(id)
   const navigate = useNavigate();
   const [roles, setRoles] = useState([]);
   const [checked, setChecked] = useState(false);
   const [upload, setUpload] = useState({aadhar_upload:'', pan_upload:''});
   const [otpModalOpen, setOtpModalOpen] = useState(false); // Modal state for OTP
   const [otpType, setOtpType] = useState(''); // OTP type (phone or email)
   const [otpValue, setOtpValue] = useState(''); // OTP value entered by user
   const [isEmailVerified, setIsEmailVerified] = useState(false); // OTP value entered by user
   const [isPhoneVerified, setIsPhoneVerified] = useState(false); // OTP value entered by user
   const [successModalOpen, setSuccessModalOpen] = useState(false); // Modal state for success

// x

   const formik = useFormik({
      initialValues: {
         first_name: '',
         last_name: '',
         password: '',
         email: '',
         phone: '',
         aadhar_number: '',
         pan_number: '',
         aadhar_upload: {},
         pan_upload: {},
         address: '',
         bank_name: '',
         account_number: '',
         bank_ifsc_code: '',
         bank_address: '',
         city:'',
         state:'',
         country:'',
         pincode:'',
         nominee_relation:'',
         nominee_age:'',
         nominee_name:'',
         active: 'yes',
      },
      validationSchema: AgentSchema,
      onSubmit: async (values, { setSubmitting, setFieldError, setFieldTouched }) => {
         // Check if both OTPs are verified before submitting
         if (!isEmailVerified && !isPhoneVerified) {
            setFieldError('email', 'Please verify Email OTP');
            setFieldError('phone', 'Please verify Phone OTP');
            setFieldTouched('email', true);
            setFieldTouched('phone', true);
            setSubmitting(false)
            return
         } else if (!isEmailVerified) {
            setFieldError('email', 'Please verify Email OTP');
            setFieldTouched('email', true);
            setSubmitting(false)
            return
         } else if (!isPhoneVerified) {
            setFieldError('phone', 'Please verify Phone OTP');
            setFieldTouched('phone', true);
            setSubmitting(false)
            return
         }
         
         //   console.log(values)
         const response = await Post(apiURL + '/api/v1/users//create/agent_without_auth', { ...values,qr })
         if (response && response.data && response.data.status) {
            toast.success(response.data.message)
            setSubmitting(false)
            setSuccessModalOpen(true) // Open success modal
         }
         else {
            toast.error(response?.data.message || 'Please Try Again')
            setSubmitting(false)
         }
      }
   });

   const { errors, touched, values, setFieldValue, setFieldError, setFieldTouched, isSubmitting, handleSubmit, getFieldProps, resetForm } = formik;
   // console.log(values)
   // console.log(errors)

   const handleDocUpload = async(id, file) => {
      const data = {file: id==='aadhar_upload'? 'AAdhar Card': 'Pan Card', data: file}
      const response = await Post(apiURL+ '/api/v1/users/uploaddoc', {...data}, navigate)
      if(response && response.data && response.data.status) {
      setUpload((prev)=> ({...prev, [id]: response?.data?.data?.data}))
      toast.success(`${data.file} Uploaded Successfully`)
      setFieldValue(id, response?.data?.data?.id)
      }
      else {
         toast.error(response?.data?.message || 'Please Try Again')
      }
   }

   const handleFiles = async (e) => {
      const { id, files } = e.target
      if ((files[0]['size'] / 1024) <= 2000) {
         const base64 = await Base64File(files[0])
         const file = { name: files[0]['name'], size: files[0]['size'], base64: base64 }
         handleDocUpload(id, file)
      }
      else {
         toast.error('Please Upload File less than 2 MB')
      }
   }

   const handleChangeCheck = (e) => {
      setChecked(e.target.checked)
   }

 const handleOtpOpen = async (type) => {
   const response = await Post(apiURL + `/api/v1/users/registration/_sent_otp_registration`, { entity: type === 'email' ? values.email : values.phone });
   if (response && response.data && response.data.status) {
      toast.success('OTP Verified Successfully');
      setOtpModalOpen(false);
   } else {
      toast.error('Invalid OTP. Please try again.');
   }
   if(response && response.data && response.data.status) {
    setOtpType(type);
    setOtpModalOpen(true); // Open OTP Modal
   }

 };

 const handleOtpClose = () => {
    setOtpModalOpen(false); // Close OTP Modal
 };

 const handleSuccessClose = () => {
    setSuccessModalOpen(false); // Close Success Modal
    resetForm(); // Reset the form
    setIsEmailVerified(false); // Reset verification states
    setIsPhoneVerified(false);
    setChecked(false); // Reset checkbox
    setUpload({aadhar_upload:'', pan_upload:''}); // Reset uploads
 };

 const handleOtpSubmit = async () => {
    const response = await Post(apiURL + `/api/v1/users/registration/_verify_otp_registration`, { entity: otpType === 'email' ? values.email : values.phone, otp: otpValue });
    if (response && response.data && response.data.status) {
       toast.success('OTP Verified Successfully');
       setOtpModalOpen(false);
       if(otpType === 'email')
          { 
            setIsEmailVerified(true)
            setFieldError('email', ''); // Clear email error on successful verification
       }else{
         setIsPhoneVerified(true)
         setFieldError('phone', ''); // Clear phone error on successful verification
       }
    } else {
       toast.error('Invalid OTP. Please try again.');
    }
 };


   return (
     <FormikProvider value={formik}>
       <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
         <Card>
           <CardContent>
             <Typography align="center" variant="h4">
               CREATE AGENTS
             </Typography>
             <Grid container spacing={2} sx={{ mt: 0 }}>
               <Grid item xs={12} sm={12} lg={6} md={6} xl={6}>
                 <TextField
                   fullWidth
                   label="First Name"
                   {...getFieldProps("first_name")}
                   error={Boolean(touched.first_name && errors.first_name)}
                   helperText={touched.first_name && errors.first_name}
                 />
               </Grid>
               <Grid item xs={12} sm={12} lg={6} md={6} xl={6}>
                 <TextField
                   fullWidth
                   label="Last Name"
                   {...getFieldProps("last_name")}
                   error={Boolean(touched.last_name && errors.last_name)}
                   helperText={touched.last_name && errors.last_name}
                 />
               </Grid>
             </Grid>

             <Grid container spacing={2} sx={{ mt: 0 }}>
               <Grid item xs={12} sm={12} lg={6} md={6} xl={6}>
                 <TextField
                   fullWidth
                   label="Email Address"
                   {...getFieldProps("email")}
                   error={Boolean(touched.email && errors.email)}
                   helperText={touched.email && errors.email}
                   disabled={isEmailVerified}
                   InputProps={{
                     endAdornment: (
                       <InputAdornment position="end">
                         {isEmailVerified ? (
                           <Typography
                             sx={{ mt: 1, color: "green" }}
                           > <CheckCircleIcon sx={{ }} /> 
                           </Typography>
                         ) : (
                           <Button
                             variant="outlined"
                             size="small"
                             onClick={() => handleOtpOpen("email")} // Trigger OTP verification
                           >
                             Verify
                           </Button>
                         )}{" "}
                       </InputAdornment>
                     ),
                   }}
                 />
               </Grid>
               <Grid item xs={12} sm={12} lg={6} md={6} xl={6}>
                 <TextField
                   fullWidth
                   label="M-Pin"
                   {...getFieldProps("password")}
                   error={Boolean(touched.password && errors.password)}
                   helperText={
                     (touched.password && errors.password) ||
                     "Enter 4 digit M-Pin"
                   }
                 />
               </Grid>
             </Grid>

             <Divider />
             <Grid container spacing={2} sx={{ mt: 0 }}>
               <Grid item xs={12} sm={12} lg={4} md={6} xl={4}>
                 <TextField
                   fullWidth
                   label="Phone Number"
                   {...getFieldProps("phone")}
                   error={Boolean(touched.phone && errors.phone)}
                   helperText={touched.phone && errors.phone}
                   disabled={isPhoneVerified}
                   InputProps={{
                     endAdornment: (
                       <InputAdornment position="end">
                         {isPhoneVerified ? (
                           <Typography
                             sx={{ mt: 1, color: "green" }}
                           >
                              <CheckCircleIcon sx={{ }} /> 
                           </Typography>
                         ) : (
                           <Button
                             variant="outlined"
                             size="small"
                             onClick={() => handleOtpOpen("phone")} // Trigger OTP verification
                           >
                             Verify
                           </Button>
                         )}{" "}
                       </InputAdornment>
                     ),
                   }}
                 />
               </Grid>
               <Grid item xs={12} sm={12} lg={4} md={6} xl={4}>
                 <TextField
                   fullWidth
                   label="Aadhar Number"
                   {...getFieldProps("aadhar_number")}
                   error={Boolean(
                     touched.aadhar_number && errors.aadhar_number
                   )}
                   helperText={touched.aadhar_number && errors.aadhar_number}
                 />
               </Grid>
               <Grid item xs={12} sm={12} lg={4} md={6} xl={4}>
                 <TextField
                   fullWidth
                   label="Pan Number"
                   {...getFieldProps("pan_number")}
                   error={Boolean(touched.pan_number && errors.pan_number)}
                   helperText={touched.pan_number && errors.pan_number}
                 />
               </Grid>
             </Grid>

             <Grid container spacing={2} sx={{ mt: 0 }}>
               <Grid item xs={12} sm={12} lg={4} md={6} xl={4}>
                 {/* <TextField fullWidth  label="Company Name" {...getFieldProps('company_name')} error={Boolean(touched.company_name && errors.company_name)} helperText={touched.company_name && errors.company_name} /> */}
                 <Stack spacing={2}>
                   <Button
                     component="label"
                     variant="contained"
                     startIcon={<CloudUploadIcon />}
                   >
                     Upload Aadhar
                     <VisuallyHiddenInput
                       id="aadhar_upload"
                       type="file"
                       onChange={(e) => handleFiles(e)}
                     />
                   </Button>
                   <Stack direction={"row"} spacing={1}>
                     <Typography sx={{ display: "flex", alignItems: "center" }}>
                       {upload.aadhar_upload?.["name"]
                         ? upload.aadhar_upload?.["name"]
                         : "No File Choosen"}
                     </Typography>
                     {upload.aadhar_upload?.["name"] ? (
                       <IconButton
                         component={"a"}
                         href={dataURItoBlob(upload.aadhar_upload?.["base64"])}
                         target="_blank"
                       >
                         <LaunchIcon />
                       </IconButton>
                     ) : null}
                   </Stack>
                 </Stack>
               </Grid>
               <Grid item xs={12} sm={12} lg={4} md={6} xl={4}>
                 {/* <TextField fullWidth label="Company Address" {...getFieldProps('address')} error={Boolean(touched.address && errors.address)} helperText={touched.address && errors.address} /> */}
                 <Stack spacing={2}>
                   <Button
                     component="label"
                     variant="contained"
                     startIcon={<CloudUploadIcon />}
                   >
                     Upload Pan Card
                     <VisuallyHiddenInput
                       id="pan_upload"
                       type="file"
                       onChange={(e) => handleFiles(e)}
                     />
                   </Button>
                   <Stack direction={"row"} spacing={1}>
                     <Typography sx={{ display: "flex", alignItems: "center" }}>
                       {upload.pan_upload?.["name"]
                         ? upload.pan_upload?.["name"]
                         : "No File Choosen"}
                     </Typography>
                     {upload.pan_upload?.["name"] ? (
                       <IconButton
                         component={"a"}
                         href={dataURItoBlob(upload.pan_upload?.["base64"])}
                         target="_blank"
                       >
                         <LaunchIcon />
                       </IconButton>
                     ) : null}
                   </Stack>
                 </Stack>
               </Grid>
             </Grid>

             <Grid container spacing={2} sx={{ mt: 0 }}>
               <Grid item xs={12} sm={12} lg={4} md={6} xl={4}>
                 <TextField
                   fullWidth
                   label="Personal Address"
                   {...getFieldProps("address")}
                   error={Boolean(touched.address && errors.address)}
                   helperText={touched.address && errors.address}
                 />
               </Grid>
               <Grid item xs={12} sm={12} lg={4} md={6} xl={4}>
                 <TextField
                   fullWidth
                   label="City"
                   {...getFieldProps("city")}
                   error={Boolean(touched.city && errors.city)}
                   helperText={touched.city && errors.city}
                 />
               </Grid>
               <Grid item xs={12} sm={12} lg={4} md={6} xl={4}>
                 <TextField
                   fullWidth
                   label="State"
                   {...getFieldProps("state")}
                   error={Boolean(touched.state && errors.state)}
                   helperText={touched.state && errors.state}
                 />
               </Grid>
               <Grid item xs={12} sm={12} lg={4} md={6} xl={4}>
                 <TextField
                   fullWidth
                   label="Country"
                   {...getFieldProps("country")}
                   error={Boolean(touched.country && errors.country)}
                   helperText={touched.country && errors.country}
                 />
               </Grid>
               <Grid item xs={12} sm={12} lg={4} md={6} xl={4}>
                 <TextField
                   fullWidth
                   label="Pincode"
                   {...getFieldProps("pincode")}
                   error={Boolean(touched.pincode && errors.pincode)}
                   helperText={touched.pincode && errors.pincode}
                 />
               </Grid>
             </Grid>

             <Grid container spacing={2} sx={{ mt: 0 }}>
               <Grid item xs={12} sm={12} lg={4} md={6} xl={4}>
                 <TextField
                   fullWidth
                   label="Bank Name"
                   {...getFieldProps("bank_name")}
                   error={Boolean(touched.bank_name && errors.bank_name)}
                   helperText={touched.bank_name && errors.bank_name}
                 />
               </Grid>
               <Grid item xs={12} sm={12} lg={4} md={6} xl={4}>
                 <TextField
                   fullWidth
                   label="Account Number"
                   {...getFieldProps("account_number")}
                   error={Boolean(
                     touched.account_number && errors.account_number
                   )}
                   helperText={touched.account_number && errors.account_number}
                 />
               </Grid>
               <Grid item xs={12} sm={12} lg={4} md={6} xl={4}>
                 <TextField
                   fullWidth
                   label="IFSC Code"
                   {...getFieldProps("bank_ifsc_code")}
                   error={Boolean(
                     touched.bank_ifsc_code && errors.bank_ifsc_code
                   )}
                   helperText={touched.bank_ifsc_code && errors.bank_ifsc_code}
                 />
               </Grid>
             </Grid>

             <Grid container spacing={2} sx={{ mt: 0 }}>
               <Grid item xs={12} sm={12} lg={4} md={6} xl={4}>
                 <TextField
                   fullWidth
                   label="Bank Address"
                   {...getFieldProps("bank_address")}
                   error={Boolean(touched.bank_address && errors.bank_address)}
                   helperText={touched.bank_address && errors.bank_address}
                 />
               </Grid>

               <Grid item xs={12} sm={12} lg={4} md={6} xl={4}>
                 {/* <TextField fullWidth label="Active" {...getFieldProps('active')} error={Boolean(touched.active && errors.active)} helperText={touched.active && errors.active} /> */}
                 <FormControl
                   fullWidth
                   error={Boolean(touched.active && errors.active)}
                 >
                   <InputLabel id="active">Active</InputLabel>
                   <Select
                     id="active"
                     value={values.active}
                     label="Active"
                     onChange={(e) => setFieldValue("active", e.target.value)}
                   >
                     <MenuItem value={"yes"}>Yes</MenuItem>
                     <MenuItem value={"no"}>No</MenuItem>
                   </Select>
                   <FormHelperText>
                     {touched.active && errors.active}
                   </FormHelperText>
                 </FormControl>
               </Grid>
             </Grid>

             <Grid container spacing={2} sx={{ mt: 0 }}>
               <Grid item xs={12} sm={12} lg={4} md={6} xl={4}>
                 <TextField
                   fullWidth
                   label="Nominee Name"
                   {...getFieldProps("nominee_name")}
                   error={Boolean(touched.nominee_name && errors.nominee_name)}
                   helperText={touched.nominee_name && errors.nominee_name}
                 />
               </Grid>
               <Grid item xs={12} sm={12} lg={4} md={6} xl={4}>
                 <TextField
                   type="number"
                   fullWidth
                   label="Nominee Age"
                   InputProps={{ inputProps: { min: 0, max: 100 } }}
                   {...getFieldProps("nominee_age")}
                   error={Boolean(touched.nominee_age && errors.nominee_age)}
                   helperText={touched.nominee_age && errors.nominee_age}
                 />
               </Grid>
               <Grid item xs={12} sm={12} lg={4} md={6} xl={4}>
                 <TextField
                   fullWidth
                   label="Nominee Relation"
                   {...getFieldProps("nominee_relation")}
                   error={Boolean(
                     touched.nominee_relation && errors.nominee_relation
                   )}
                   helperText={
                     touched.nominee_relation && errors.nominee_relation
                   }
                 />
               </Grid>
             </Grid>
           </CardContent>

           <Stack ml={"20px"} spacing={1} direction={"row"}>
             <FormControlLabel
               value="end"
               control={
                 <Checkbox checked={checked} onChange={handleChangeCheck} />
               }
               label=""
               labelPlacement="end"
             />
             <Typography
               align="center"
               justifyContent={"center"}
               display={"flex"}
               alignItems={"center"}
             >
               I Accept the{" "}
               <a
                 href={require("../../../img/terms and conditions.pdf")}
                 target="_blank"
                 style={{ cursor: "pointer", marginLeft: "5px" }}
               >
                 Terms and Conditions
               </a>
             </Typography>
           </Stack>
           <CardActions
             sx={{ display: "flex", justifyContent: "space-between" }}
           >
             <Button
               href="#/dashboard/agentUser"
               variant="contained"
               sx={{
                 backgroundColor: "#3f51b5",
                 "&:hover": { color: "#ffff", backgroundColor: "#3f51b5" },
               }}
             >
               Back
             </Button>
             <LoadingButton
               size="large"
               type="submit"
               variant="contained"
               loading={isSubmitting}
               disabled={!checked || !isEmailVerified || !isPhoneVerified}
               sx={{
                 backgroundColor: "#3f51b5",
                 "&:hover": { color: "#ffff", backgroundColor: "#3f51b5" },
               }}
             >
               Save{" "}
             </LoadingButton>
           </CardActions>
         </Card>
         <Modal open={otpModalOpen} onClose={handleOtpClose}>
           <Box
             sx={{
               padding: 4,
               width: 400,
               margin: "auto",
               backgroundColor: "white",
             }}
           >
             <Typography variant="h6" align="center">
               Enter OTP for {otpType === "email" ? "Email" : "Phone"}
             </Typography>
             <TextField
               fullWidth
               label="OTP"
               type="text"
               value={otpValue}
               onChange={(e) => setOtpValue(e.target.value)}
               error={Boolean(!otpValue)}
               helperText={!otpValue ? "OTP is required" : ""}
             />
             <Button
               variant="contained"
               sx={{ marginTop: 2 }}
               onClick={handleOtpSubmit}
             >
               Verify OTP
             </Button>
           </Box>
         </Modal>

         {/* Success Modal */}
         <Modal open={successModalOpen} onClose={handleSuccessClose}>
           <Box
             sx={{
               position: 'absolute',
               top: '50%',
               left: '50%',
               transform: 'translate(-50%, -50%)',
               width: 400,
               backgroundColor: 'white',
               borderRadius: 2,
               boxShadow: 24,
               p: 4,
               textAlign: 'center'
             }}
           >
             <CheckCircleIcon 
               sx={{ 
                 fontSize: 64, 
                 color: 'success.main', 
                 mb: 2 
               }} 
             />
             <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
               Agent Created Successfully!
             </Typography>
             <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary' }}>
               The agent has been successfully registered in the system.
             </Typography>
             <Stack direction="row" spacing={2} justifyContent="center">
               <Button
                 variant="outlined"
                 onClick={handleSuccessClose}
                 sx={{ minWidth: 100 }}
               >
                 Create Another
               </Button>
               <Button
                 variant="contained"
                 onClick={() => {
                   handleSuccessClose();
                   navigate('/dashboard/agentUser');
                 }}
                 sx={{ minWidth: 100 }}
               >
                 Go to Dashboard
               </Button>
             </Stack>
           </Box>
         </Modal>
       </Form>
     </FormikProvider>
   );
};

export default AgentCreate;

const VisuallyHiddenInput = styled('input')({
   clip: 'rect(0 0 0 0)',
   clipPath: 'inset(50%)',
   height: 1,
   overflow: 'hidden',
   position: 'absolute',
   bottom: 0,
   left: 0,
   whiteSpace: 'nowrap',
   width: 1,
});